import {
    UPDATE_BASKET_PACKAGE_ITEM,
    UPDATE_BASKET_PACKAGE_ITEM_ERROR,
    UPDATE_BASKET_PACKAGE_ITEM_SUCCESS,
} from "core-web/state/models/Basket/constants";

import { BasketEvents } from "core-web/libs/Events/constants";
import Events from "core-web/libs/Events";
import UpdateBasketPackage from "core-web/libs/GrebbCommerceAPI/Basket/UpdateBasketPackage";
import { acquireMutex } from "core-web/state";
import buildCartProductTree from "core-web/utils/buildCartProductTree";
import createBasket from "core-web/state/models/Basket/dispatches/createBasket";
import getBasketId from "core-web/state/models/Basket/utils/getBasketId";
import setBasketItemsAmountCookie from "core-web/state/models/Basket/utils/setBasketItemsAmountCookie";
import store from "core-web/state/store";
import tracking from "core-web/components/Tracking";

export const updateBasketPackageItem = (item, quantity, source) => async (dispatch) => {
    const basketId = await getBasketId();
    const mutexLock = await acquireMutex("basket.getBasket");
    const eventId = tracking.getUniqueId();

    if (!basketId) {
        await createBasket();
    }

    dispatch({ type: UPDATE_BASKET_PACKAGE_ITEM });
    try {
        const response = await UpdateBasketPackage(basketId, item.line_no, quantity, eventId);

        const basketItemsTree = buildCartProductTree(response.data.items);
        const basketItemsCount = basketItemsTree.reduce((total, item) => total + (item.quantity || 0), 0);
        setBasketItemsAmountCookie(basketItemsCount);

        dispatch({
            type: UPDATE_BASKET_PACKAGE_ITEM_SUCCESS,
            items: basketItemsTree,
            info: response.data.info,
            summary: response.data.format.summary,
            promotions: response.data.applied_promotions,
        });
        Events.trigger(BasketEvents.UPDATED);

        const itemClone = { ...item };

        if (source === "add") {
            itemClone.quantity = quantity - item.quantity;
            Events.trigger(BasketEvents.PRODUCT_ADDED, { basketId, item: itemClone, eventId });
        } else if (source === "remove") {
            itemClone.quantity = item.quantity - quantity;
            Events.trigger(BasketEvents.PRODUCT_REMOVED, { item: itemClone, basket: basketId });
        }

        mutexLock();

        return response;
    } catch (e) {
        dispatch({ type: UPDATE_BASKET_PACKAGE_ITEM_ERROR });
        mutexLock();
        throw e;
    }
};

export default (item, quantity, source) => store.dispatch(updateBasketPackageItem(item, quantity, source));
